import React from 'react';

const Header = () => {
  return (
    <div className="container">
        <h1 className="my-4 text-center fw-bolder">FoodieFynd</h1>
        <h3 className='text-center fw-normal pb-4'>Don't know what to eat? Randomize now!</h3>
    </div>
  );
};

export default Header;
